import { Typography, Box } from '@mui/material';
import ExcelUploadSection from './ExcelUploadSection';

const DocsStudents = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Students
      </Typography>

      <Typography variant="body1" paragraph>
        Student groups represent a section/class or batch of students enrolled
        in the same set of courses. Each student group must be registered and
        assigned to the appropriate subjects or courses to ensure accurate
        scheduling and a smooth learning experience.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Adding a Student Group
      </Typography>

      <ExcelUploadSection />

      <Typography variant="body1" paragraph>
        To add a new student group, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Students</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the department to which the Student Group is associated with.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the student groups unique code (e.g., SEM-1, CS_2019,
            Class-VII).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Specify the name and description of the student group.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Specify the strength i.e total number of students enrolled in the
            group.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to add the student.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Assigning Subjects
      </Typography>
      <Typography variant="body1" paragraph>
        You must assign the subjects to the student group that they are expected
        to undertake as part of their curriculum:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Click on <strong>Assign Subject</strong> for a particular group.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the <strong>Subject</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Managing Students
      </Typography>
      <Typography variant="body1" paragraph>
        You can manage student records efficiently:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Editing:</strong> Click on the edit(pencil) button to modify
            student group's details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Deleting:</strong> Click on the edit(pencil) button and
            select delete if they are no longer active.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsStudents;
